import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from 'api/axios';
import { buildQueryString } from 'utils/general';

const initialState = {
	currentOpenDrawer: '',
	loading: false,
	allProductsList: [],
	pagination: {
		page: 1,
		limit: 10,
		totalPages: 0,
		totalResults: 0,
	},
	drawerVaues: {
		VIEW_PRODUCT_DETAILS: 'VIEW_PRODUCT_DETAILS',
		PRODUCT_FILTER: 'PRODUCT_FILTER',
	},
};

// Product Management CRUD operations API calls

export const fetchAllProducts = createAsyncThunk('productManagement/fetchAllProducts', async (options, { rejectWithValue }) => {
	// API call to fetch all products
	try {
		const query = buildQueryString({
			search: options.search,
			type: options.type,
			startDate: options.startDate,
			endDate: options.endDate,
			isActive: options.isActive?.toString(),
			page: options.page,
			limit: options.limit,
			sortBy: options.sortBy,
			appealed: options.appealed,
			categoryId: options.categoryId,
			subCategoryId: options.subCategoryId,
			appealType: options.appealType,
			targetEmail: options.targetEmail,
			postedFrom: options.postedFrom,
			sold: options.sold,
			soldType: options.soldType,
			typeId: options.targetTypeId,
			translationFailed: options.translationFailed,
		});

		const response = await axiosInstance.get(`/post/admin?${query}`);

		if (response.success) {
			return response;
		}

		rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response.data);
	}
});

export const updateProduct = createAsyncThunk('productManagement/updateProduct', async ({ data, id, isActive }, { rejectWithValue, dispatch }) => {
	try {
		const response = await axiosInstance.patch(`/post/admin/${id}`, data);

		if (response.success) {
			const options = {
				page: 1,
				limit: 10,
				isActive,
			};

			dispatch(fetchAllProducts(options));

			return response;
		}

		return rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response.data);
	}
});

export const uploadFile = async (file) => {
	try {
		const formData = new FormData();
		formData.append('document', file);

		const response = await axiosInstance.post(`/post/upload/file`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});

		return response;
	} catch (error) {
		console.error(error);
	}
};

export const deleteProduct = createAsyncThunk('productManagement/deleteProduct', async (productId, { rejectWithValue, dispatch }) => {
	// API call to delete a product
	try {
		const response = await axiosInstance.delete(`/post/${productId}`);

		if (response.success) {
			const options = {
				page: 1,
				limit: 10,
			};

			dispatch(fetchAllProducts(options));
			console.log('response :>> ', response);
			return response;
		}

		return rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response.data);
	}
});

export const productManagementSlice = createSlice({
	name: 'productManagement',
	initialState,
	reducers: {
		setCurrentOpenDraverValueTo: (state, action) => {
			state.currentOpenDrawer = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchAllProducts.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchAllProducts.fulfilled, (state, { payload }) => {
				state.loading = false;
				state.allProductsList = payload.result.data;
				state.pagination = {
					page: payload.result.page,
					limit: payload.result.limit,
					totalPages: payload.result.totalPages,
					totalResults: payload.result.totalResults,
				};
			})
			.addCase(fetchAllProducts.rejected, (state) => {
				state.loading = false;
			})
			.addCase(deleteProduct.pending, (state) => {
				state.loading = true;
			})
			.addCase(deleteProduct.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(deleteProduct.rejected, (state) => {
				state.loading = false;
			});
	},
});

export const { setCurrentOpenDraverValueTo } = productManagementSlice.actions;

export default productManagementSlice.reducer;
